import { z } from "zod";
import { PublicIdSchema } from "./common";
import { CreateExpenseInput, DriverExpense, UpdateExpenseInput } from "./driver-expense";

export const AdminExpense = DriverExpense.extend({
  driver_public_id: PublicIdSchema,
  driver_name: z.string(),
  /** #616: 代理入力した事務担当の氏名。本人入力・登録者不明は null。 */
  entered_by_name: z.string().nullable(),
});

export const ListAdminExpensesInput = z.object({
  driver_public_id: PublicIdSchema.optional(),
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(100),
  /** #537: サーバサイドページングの開始位置 (1 か月 1800 件で末尾に到達できなかった)。 */
  offset: z.coerce.number().int().min(0).default(0),
});

/**
 * #616: 管理側の代理入力。ETC のように金額が後日確定する経費を事務が補完する。
 * 対象ドライバーを明示する以外はドライバー本人の登録と同じ入力。
 */
export const CreateAdminExpenseInput = CreateExpenseInput.extend({
  driver_public_id: PublicIdSchema,
});

/** #616: 管理側の代理修正。対象日・所有者は変更できない (ドライバー本人の更新と同じ制約)。 */
export const UpdateAdminExpenseInput = UpdateExpenseInput;

/** #616: 代理入力時の紐付け先候補。ドライバーと対象日を指定して取得する。 */
export const ListAdminExpenseStopOptionsInput = z.object({
  driver_public_id: PublicIdSchema,
  date: z.iso.date(),
});

/**
 * #616: 注文詳細からの経費登録用。その注文の配達 stop を返す。
 * 担当ドライバー・配送日も候補に含むため、呼出側は注文だけ知っていればよい。
 */
export const ListOrderExpenseStopsInput = z.object({
  publicId: PublicIdSchema,
});

export type AdminExpenseDto = z.infer<typeof AdminExpense>;
export type ListAdminExpensesInputDto = z.infer<typeof ListAdminExpensesInput>;
export type CreateAdminExpenseInputDto = z.infer<typeof CreateAdminExpenseInput>;
export type UpdateAdminExpenseInputDto = z.infer<typeof UpdateAdminExpenseInput>;
export type ListAdminExpenseStopOptionsInputDto = z.infer<typeof ListAdminExpenseStopOptionsInput>;
export type ListOrderExpenseStopsInputDto = z.infer<typeof ListOrderExpenseStopsInput>;
